import { apiFetch } from './api';

export interface IntervalPayload {
  dateKey: string;
  intervalMinutes: number;
  startTs: number;
  endTs: number;
  answer: 'yes' | 'no';
  pauseCount: number;
  pausedSeconds: number;
}

export interface IntervalRecord extends IntervalPayload {
  id: string;
}

export const createInterval = (payload: IntervalPayload) =>
  apiFetch<{ id: string }>(`/intervals`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });

export const listIntervals = (startDate: string, endDate: string) =>
  apiFetch<{ items: IntervalRecord[] }>(`/intervals?startDate=${startDate}&endDate=${endDate}`);
